<template>
  <div>
    <card class="w-100">
      <el-row :gutter="10">
        <form @submit.prevent="changePage(1)">
          <el-col :span="2">
            <div class="form-group">
              <label>권한</label>
              <el-select v-model="search.searchRoleCode" @change="changeRoleCode">
                <el-option
                  key=""
                  value=""
                  label="전체"></el-option>
                <el-option
                  v-for="item in this.$store.state.common.roles"
                  :key="item.roleCode"
                  :label="item.roleName"
                  :value="item.roleCode">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <!-- <el-col :span="2">
            <div class="form-group">
              <label>계정종류</label>
              <el-select v-model="search.searchMasterYn" @change="changeRoleCode">
                <el-option
                  key=""
                  value=""
                  label="전체"></el-option>
                <el-option
                  label="관리자계정"
                  value="X">
                </el-option>
                <el-option
                  label="대표계정"
                  value="Y">
                </el-option>
                <el-option
                  label="광고주 담당자계정"
                  value="N">
                </el-option>
              </el-select>
            </div>
          </el-col> -->
          <el-col :span="2">
            <div class="form-group">
              <label>계정상태</label>
              <el-select v-model="search.searchStatus" @change="changeRoleCode">
                <el-option
                  key=""
                  value=""
                  label="전체"></el-option>
                <el-option
                  label="승인"
                  value="OK">
                </el-option>
                <el-option
                  label="승인 대기중"
                  value="READY">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="form-group">
              <label>업체명 or 이름</label>
              <el-input v-model="search.searchName" placeholder="업체명 or 이름 검색">
              </el-input>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="form-group">
              <label>사업자등록번호</label>
              <el-input v-model="search.searchId" placeholder="사업자등록번호">
              </el-input>
            </div>
          </el-col>
          <el-col :span="2">
            <div class="form-group">
              <label>페이지당 리스트수</label>
              <el-select v-model="perPage">
                <el-option
                  key="10"
                  value="10"
                />
                <el-option
                  key="20"
                  value="20"
                />
                <el-option
                  key="30"
                  value="30"
                />
                <el-option
                  key="50"
                  value="50"
                />
                <el-option
                  key="100"
                  value="100"
                />
              </el-select>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="mt-4">
              <el-button type="primary" native-type="submit" icon="el-icon-search">검색</el-button>
              <el-button type="primary" @click="resetPage" icon="el-icon-refresh">초기화</el-button>
              <!-- <el-button class="pull-right" type="primary" icon="el-icon-plus" v-on:click="register">계정 등록</el-button> -->


              <el-dropdown @command="addAccountClick" class="pull-right" >
                  <el-button type="primary" icon="el-icon-plus" >계정 등록 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
                  <el-dropdown-menu slot="dropdown">
                        
                    <el-dropdown-item v-for="item in $store.state.common.roles" :command="item.roleCode"> 
                      {{item.roleName}} {{item.roleName == '광고주' ? '담당자' : ''}}
                    </el-dropdown-item>
                    <!-- <el-dropdown-item divided command="Damdang"> 광고주 담당자</el-dropdown-item> -->
                     
                  </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown @command="excel" class="mr-2 pull-right" >
                  <el-button type="primary" icon="el-icon-download" >엑셀 다운로드 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
                  <el-dropdown-menu slot="dropdown">
                        
                    <el-dropdown-item command="check"> 체크된 데이터 다운로드</el-dropdown-item>
                    <el-dropdown-item divided command="all"> 검색된 데이터 모두 다운로드</el-dropdown-item>
                      
                  </el-dropdown-menu>
              </el-dropdown>

            </div>
          </el-col>
        </form>
      </el-row>
    </card>
    <card class="w-100">
      <h6 class="pull-right mr-4">총 {{$store.state.settingsAccount.total | numeral('0,0')}}개 검색됨</h6>
      <!-- <div class="">
        <i class="el-icon-office-building text-primary2"></i> 관리자계정
        <i class="el-icon-star-on text-danger ml-3"></i> 대표계정
        <i class="el-icon-user-solid text-primary2 ml-3"></i> 광고주 담당자계정
      </div> -->
      <el-col :span="24">
<!-- 
        <aw-table 
              class="table-striped"
                v-sync-height="{model='ui.tvHeight',offset:10}"
                :fixed-body-header="true"
                :height="ui.tvHeight"
                drag-scroll-dir="x"
                :border="true"
                ref="accountTable"
                :data="$store.state.settingsAccount.accounts"
                :header-cell-style="tableRowStyle"
        > -->

        <aw-table 
              class="table-striped"
                :fixed-body-header="true"
                drag-scroll-dir="x"
                :border="true"
                ref="accountTable"
                :data="$store.state.settingsAccount.accounts"
                :header-cell-style="tableRowStyle"
                @selection-change="handleSelectionChange"
        >
          <el-table-column
            fixed
            type="selection"
            width="55">
          </el-table-column>

          <el-table-column
            fixed
            sortable
            prop="roleName" width="100px"
            label="권한">
          </el-table-column>
          <!-- <el-table-column class="text-center"
            fixed
            sortable
            width="50px"
            label="계정">
            <template slot-scope="props">
            <div>
              <div class="text-center" v-if="/ADVERTISER|AGENT/.test(props.row.roleCode)">
                <span v-if="props.row.masterYn === 'Y'"><i class="el-icon-star-on text-danger"></i></span>
                <span v-if="props.row.masterYn !== 'Y'"><i class="el-icon-user-solid text-primary2"></i></span>
              </div>
              <div class="text-center" v-if="!/ADVERTISER|AGENT/.test(props.row.roleCode)">
                <span><i class="el-icon-office-building text-primary2"></i></span>
              </div>
            </div>
            </template>
          </el-table-column> -->
          <el-table-column class="text-center"
            fixed
            sortable
            width="70px"
            prop="status"
            label="상태">
            <template slot-scope="props">
              <div class="text-center" >
                <span v-if="props.row.status === 'READY'" class="text-danger">대기</span>
                <span v-if="props.row.status === 'OK'" class="text-success">승인</span>
                <span v-if="props.row.status === 'REMOVE'" class="text-danger">삭제</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
          fixed
          sortable
            prop="companyName"
            label="업체명">
          </el-table-column>
          <el-table-column
          sortable
            prop="licenseNumber" width="140px"
            label="사업자등록번호">
          </el-table-column>
          <el-table-column
          sortable
            prop="userId"
            label="아이디">
          </el-table-column>
          <el-table-column
          sortable
            prop="department" width="140"
            label="부서">
          </el-table-column>
          <el-table-column
          sortable
            prop="userName"
            label="이름">
          </el-table-column>
          <el-table-column width="130"
          sortable
            prop="phone1"
            label="연락처">
          </el-table-column>
          <el-table-column
          sortable
            prop="email"
            label="이메일">
          </el-table-column>
          <el-table-column
          sortable
          prop="regDate"
            label="등록일"
            width="110">
            <template slot-scope="props">
              {{ props.row.regDate | moment('YYYY-MM-DD')}}
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="관리"
            align="center"
            width="70">
            <template slot-scope="props">
              <div class="text-center">

                <el-button  size="mini" icon="el-icon-edit" @click="menuClick( {command:'edit',row:props.row })"></el-button>

                <!-- <el-dropdown v-if="/ADVERTISER|AGENT/.test(props.row.roleCode)" @command="menuClick" trigger="click"> -->
                <!-- <el-dropdown @command="menuClick" trigger="click">
                  <span class="el-dropdown-link">
                    <i class="el-icon-more"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">

                    <el-dropdown-item icon="el-icon-edit" :command="{command: 'edit', row: props.row}"> 계정수정</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-user-solid" :command="{command: 'sub-user-list', row: props.row}"> 업체별 계정관리</el-dropdown-item>
                    <el-dropdown-item divided :command="{command: 'change-status', row: props.row, status:'OK', statusName:'가입승인'}" v-if="props.row.masterYn === 'N' && props.row.status === 'READY'" icon="el-icon-success"> 가입승인 처리</el-dropdown-item>
                    <el-dropdown-item :command="{command: 'reset-pwd', row: props.row}" divided v-if="props.row.masterYn === 'N'" icon="el-icon-lock"> 비밀번호 초기화</el-dropdown-item>

                  </el-dropdown-menu>
                </el-dropdown> -->
              </div>

            </template>
          </el-table-column>
        </aw-table>
      </el-col>
      <el-col :span="24">
        <p-pagination class="pull-right mt-3"
                      v-on:input="changePage"
                      v-model="search.pagination.currentPage"
                      :per-page="parseInt(search.pagination.perPage)"
                      :total="$store.state.settingsAccount.total">
        </p-pagination>
      </el-col>
      <el-col :span="24">
        <!-- <div class="pull-right">
          <el-button type="primary" icon="el-icon-plus" v-on:click="register">계정 등록</el-button>
        </div> -->
        <el-dropdown @command="addAccountClick" class="pull-right" >
                  <el-button type="primary" icon="el-icon-plus" >계정 등록 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
                  <el-dropdown-menu slot="dropdown">
                        
                    <el-dropdown-item v-for="item in $store.state.common.roles" :command="item.roleCode"> {{item.roleName}}</el-dropdown-item>
                    <el-dropdown-item divided command="Damdang"> 광고주 담당자</el-dropdown-item>
                     
                  </el-dropdown-menu>
        </el-dropdown>
        
        <el-dropdown @command="excel" >
            <el-button type="primary" icon="el-icon-download" >엑셀 다운로드 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
                  
              <el-dropdown-item command="check"> 체크된 데이터 다운로드</el-dropdown-item>
              <el-dropdown-item divided command="all"> 검색된 데이터 모두 다운로드</el-dropdown-item>
                
            </el-dropdown-menu>
        </el-dropdown>

      </el-col>
    </card>
  </div>

</template>

<script>
  
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import SettingsAccountEditSubUserModal from './SettingsAccountEditSubUserModal.vue'
  import CommonProxy from '@/proxies/CommonProxy'
  import AwTable from '@/components/UIComponents/Table/AwTable.vue'
  

  export default {
    name: "SettingsAccount",
    components: {
      PPagination,
      AwTable
    },
    created: function () {

      this.cleanSearch = {...this.search}
      this.search = {...this.cleanSearch, ...this.$route.params}

      this.$store.dispatch('common/setMenuTitle', "계정 관리");
      this.$store.dispatch('common/roleFindAll');
      
      this.changePage( this.search.pagination.currentPage || 1)
      .then(() => window.scrollTo(0,this.search.scroll))
      

    },
    updated: function () {
      this.$refs.accountTable.doLayout();
    },
    methods: {
      handleSelectionChange( rows ) {
        this.checkedRows = rows
      },
      tableRowStyle() {
        return this.$store.state.common.tableHeaderCellStyle;
      },
      // 계정 등록 
      addAccountClick( roleCode ) {

        if(roleCode === 'ADVERTISER' || roleCode === 'Damdang') {

          this.$modal.show(
            SettingsAccountEditSubUserModal,
            { mode: 'insert', isSelectCompany: true  },
            { width:'780px' },
            {}
          ).result.then(()=>{
            this.resetPage()
          })


        } else {
          const params = {...this.search, scroll: window.scrollY, userId: undefined, returnName: 'SettingsAccount', defaultRoleCode: roleCode }
          this.$router.push({name: 'SettingsAccountRegistration', params });
        }  

      },
      // 드롭다운 메뉴클릭
      menuClick( {command, row, status, statusName} ) {

        switch(command) {
          case 'edit':  {

            if(!/ADVERTISER|AGENT/.test(row.roleCode) || row.masterYn === 'Y') {
              this.handleEdit( row ); 
            } else {
              this.editSubUser( row )
            }
            break
          } 
          case 'edit-sub-user':  {
            if(row.masterYn === 'Y') {
              this.handleEdit( row )
            } else {
              this.editSubUser( row )
            }  
            break
          }  
          case 'change-status' : {
            if(!confirm(`${statusName} 처리 하시겠습니까?`)) return
            this.changeUserStatus( row.userId, status )
            .then(()=>alert(`${statusName} 처리 되었습니다.`))
            break
          }  
          case 'reset-pwd' : this.resetPwd( row ); break
          case 'sub-user-list' : this.subUserList( row ); break
        }

      },
      // 담당자 계정 관리
      subUserList( {companySeq} ) {

        const params = {...this.search, companySeq: companySeq, scroll: window.scrollY }
        this.$router.push({name: 'SettingsAccountSubUserList', params });

      },
      // 수정
      handleEdit({ userId }) {
        
        const params = {...this.search, userId: userId, scroll: window.scrollY, returnName: 'SettingsAccount' }
        this.$router.push({name: 'SettingsAccountEdit', params });
        
      },
      editSubUser({ userId }) {

        this.$modal.show(
          SettingsAccountEditSubUserModal,
          { changeRecord: this.changeRecord, mode: 'edit', userId  },
          { width:'780px' },
          {}
        )

      },
      changeRecord( newData ) {
        this.$store.dispatch('settingsAccount/changeRecord', newData )
      },
      register() {

        const params = {...this.search, scroll: window.scrollY, userId: undefined, returnName: 'SettingsAccount' }
        this.$router.push({name: 'SettingsAccountRegistration', params });

      },
      changePage(page) {

        const params = {...this.search, rows: this.perPage }

        if(page) {
          params.page = page
          this.search.pagination.currentPage = page;
        }      

        return this.$store.dispatch('settingsAccount/findAll', params);
      },
      excel( command ) {
        let param = ''

        if( command === 'all' ) {
          for(const key in this.search) {
            if(this.search[key] && typeof this.search[key] !== 'object') {
              param += `&${key}=${encodeURIComponent(this.search[key])}`
            }  
          }

        } else {
          if(!this.checkedRows || this.checkedRows.length == 0) {
            alert('다운로드할 계정을 체크해 주세요')
            return
          }
          const checked = []
          this.checkedRows.forEach(item=> checked.push(item.userId) )
          param = '&checked='+ encodeURIComponent(JSON.stringify(checked))
        }

        location.href = "/api/settings/accounts/excel/download?authorization=" + $cookies.get('id_token') + param;


      },
      changeRoleCode() {
        this.changePage(1);
      },
      // 화면 초기화
      resetPage() {
        this.search = {...this.cleanSearch}
        this.changePage(1);
      },
      // 상태변경
      changeUserStatus( userId, status ) {

        return this.$store.dispatch('settingsAccount/changeUserStatus', {userId, status});

      },
      resetPwd( {userId} ) {
        if(!confirm('비밀번호를 초기화 하시겠습니까?\n\n사용자의 이메일로 비밀번호초기화 안내 메일이 발송됩니다.')) {
          return
        }  
        new CommonProxy()
          .resetPwdByAdmin( userId )
          .then(response => {
            if(!response.success) {
              if(!response.found) {
                alert('해당하는 사용자를 찾을 수 없습니다.')
              } else if(!response.email) {
                alert('이메일이 없는 사용자 입니다.')
              }  

            } else {
              alert('사용자의 이메일로 비밀번호초기화 안내메일을 전송했습니다.')
            }
        })

      }

    },
    computed: {
      perPage: {
          get() {
            return this.search.pagination.perPage
          },
          set(value) {
            window.localStorage.setItem('account.reg.perPage', value)
            this.search.pagination.perPage = value
          }
        }
      },
    data() {
      return {
        ui: { tvHeight: undefined },
        search: {
          searchId: '',
          searchName: '',
          searchRoleCode: "",
          searchMasterYn: '',
          searchStatus: '',
          excludeAdver: 'Y',
          pagination: {
            perPage: window.localStorage.getItem('account.reg.perPage') || 10,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50]
          },
          scroll : 0
        },
      }
    }
  }
</script>

<style scoped>

</style>
